<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :visible="modal.show"
                   :title="title" :ok-title="$t('Submit')" modal-class="mobile-full-screen" :disable-submit-btn="loading"
                   scrollable>
      <div class="d-flex">
        <b-form-checkbox v-model="assignAll" size="lg" class="mb-2" @change="onAssignAll" switch></b-form-checkbox>
        <p class="mr-2" style="font-size: 14px">{{ $t('Reserve whole quantity') }}</p>
      </div>
      <table class="info-table table table-sm lots-table mb-0">
        <tr>
          <th style="width: 10%">{{ $t('Stock No') }}</th>
          <th style="width: 15%">{{ $t('Item Title') }}</th>
          <th style="width: 15%">{{ $t('Total Quantity') }}</th>
          <th style="width: 20%">{{ $t('Available Quantity') }}</th>
          <th style="width: 20%">{{ $t('Reserve Quantity') }}</th>
          <th style="width: 20%">{{ $t('Number of Reserves') }}</th>
        </tr>
        <tr :key="`items-to-reserve-${index}`" v-for="(model, index) of models">
          <td>
            {{ model.stock_no }}
          </td>
          <td>
            {{ model.title | striptags | truncate(50) }}
          </td>
          <td>
            {{ model.total_quantity }}
          </td>
          <td>
            {{ model.available_quantity }}
          </td>
          <td>
            <input-widget
              :rules="`required|max_value:${Math.floor(model.available_quantity/model.reserve_number)}|min_value:1`"
              :model="model" type="number"
              attribute="reserve_quantity" :label="false"/>
          </td>
          <td>
            <input-widget :rules="`required|min_value:1`" :model="model" type="number"
                          attribute="reserve_number" :label="false"/>
          </td>
        </tr>
      </table>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import BulkAssignToSaleModel from "./BulkAssignToSale.model";
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import InventoryService from "@/modules/inventory/InventoryService";
  import {SOURCE_RESERVE_ITEMS_MODAL} from "@/modules/constants";
  import LotsService from "@/modules/lots/LotsService";
  import helperService from "@/core/services/helper.service";

  const {mapActions, mapState} = createNamespacedHelpers('inventory');
  const {mapActions: lotsMapActions} = createNamespacedHelpers('lots');

  export default {
    name: "BulkAssignToSaleModal",
    components: {
      ArtisioModal,
      InputWidget
    },
    data() {
      return {
        models: [],
        assignAll: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        modal: state => state.reserveSaleModal,
        items: state => state.reserveSaleModal.items,
        sale: state => state.reserveSaleModal.sale
      }),
      title() {
        if (this.sale) {
          return this.sale.live_reference ?
            this.$i18n.t('Reserve to Sale {sale_no} - {live_ref}', {
              sale_no: this.sale.sale_no,
              live_ref: this.sale.live_reference
            }) :
            this.$i18n.t('Reserve to Sale {sale_no}', {sale_no: this.sale.sale_no});
        }
        return ''
      }
    },
    watch: {
      items() {
        this.items.forEach(item => this.models.push(new BulkAssignToSaleModel({
          "stock_no": item.stock_no,
          "inventory_uuid": item.uuid,
          "title": item.short_description,
          "total_quantity": item.quantity,
          "reservations": item.reservations,
          "available_quantity": item.available_quantity
        })))
      }
    },
    methods: {
      ...mapActions(["hideReserveSaleModal", "getTableData"]),
      ...lotsMapActions({
        getReservations: "getTableData",
      }),
      onHidden() {
        this.assignAll = false;
        this.models = [];
        this.hideReserveSaleModal()
      },
      async onSubmit() {
        this.loading = true;
        const reservation_proposals = (await LotsService.getLatestReservationProposals({
          inventory_uuids: this.models.map(item => item.inventory_uuid),
          suggestions: ['return', 'transfer'],
        })).body;
        if (reservation_proposals.length) {
          const confirm = await helperService.showProposalsConfirmationModal(reservation_proposals, this.$confirm, this.$router, this.$options.filters)
          if (!confirm) {
            this.loading = false;
            return;
          }
        }

        let data = [];
        this.models.forEach(item => {
          data.push({
            sale_no: this.sale.sale_no,
            uuid: item.inventory_uuid,
            reserve_quantity: item.reserve_quantity,
            reserve_number: item.reserve_number
          })
        });

        let response = await InventoryService.reserveLots(data)
        if (response.success) {
          this.$toast('success', this.$i18n.t('Items have been successfully assigned to sale {saleno}.', {saleno: this.sale.sale_no}));
          if (this.modal.source === SOURCE_RESERVE_ITEMS_MODAL) {
            this.getReservations();
          } else {
            this.getTableData();
          }
          this.loading = false;
          await this.hideReserveSaleModal();
        } else {
          this.loading = false;
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
        }
      },
      async onAssignAll() {
        if (!this.assignAll) {
          let showConfirm = false;
          let success = true;
          this.models.forEach(model => {
            if (model.reserve_number > 1) {
              showConfirm = true;
            }
          })
          if (showConfirm) {
            success = await this.$confirm(this.$i18n.t('Number of reserves will be set to 1. Are you sure you want to reserve whole quantity?'))
          }
          if (success) {
            this.models.forEach(model => {
              model.reserve_quantity = model.available_quantity;
              model.reserve_number = 1;
            })
          }
          else {
            this.assignAll = false;
          }
        } else {
          this.models.forEach(model => {
            model.reserve_quantity = 1;
            model.reserve_number = 1;
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
